import { AgendaVentasModule } from './../../agenda-ventas/agenda-ventas.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalVentasComponent } from './modal-ventas.component';



import { SmartadminModule } from '../../../shared/smartadmin.module';
import { TicketService } from '../../ticket.service';
import { CategoryService } from '../../../+admin/+configuraciones/+tickets/+categorias/categorias.service';
import { UsersService } from '../../../+admin/+users/users.service';
import { CustomerService } from '../../../+clientes/clientes.service';
import { TipoTicketService } from '../../../+admin/+configuraciones/+tickets/+tipos-ticket/tipos.service';

import { NgSelectModule } from '@ng-select/ng-select';
import { SmartadminInputModule } from '../../../shared/forms/input/smartadmin-input.module';
import { FoliosService } from '../../../folios/folios.service';
import {VentasService} from './ventas.service';  
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmartadminLayoutModule } from 'app/shared/layout';
import { BsModalService } from 'ngx-bootstrap';
@NgModule({
    imports: [
        NgSelectModule,
        NgZorroAntdModule,
        I18nModule,
        FormsModule,
        CommonModule
    ],
    declarations: [ModalVentasComponent],
    entryComponents: [ModalVentasComponent],
    providers: [
        TicketService,
        UsersService,
        CustomerService,
        TipoTicketService,
        CategoryService,
        FoliosService,
        VentasService,
        BsModalService
        
        
    ],
    exports: [ ModalVentasComponent ]
})

export class ModalVentasModule { }
